// Curated Quick Fact icons for Packages/Quick Trips, served from Heroicons'
// npm package via jsdelivr (pinned version — don't bump without re-checking
// the file list at https://cdn.jsdelivr.net/npm/heroicons@<version>/24/outline/).
// The stored value on a quick_fact is this URL itself, not a semantic key —
// tramango-webapp's QuickFactsRow renders it directly as an <img src>, so
// there's no icon-name registry to keep in sync between the two repos.
const HEROICONS_BASE = "https://cdn.jsdelivr.net/npm/heroicons@2.1.5/24/outline";

const ICON_NAMES = [
  ["clock", "Duration"],
  ["calendar-days", "Dates"],
  ["users", "Group size"],
  ["map-pin", "Location"],
  ["currency-dollar", "Price"],
  ["building-office-2", "Hotel"],
  ["home", "Accommodation"],
  ["truck", "Transport"],
  ["paper-airplane", "Flight/Trip"],
  ["globe-alt", "Destination"],
  ["sun", "Daytime/Beach"],
  ["moon", "Nights"],
  ["shield-check", "Verified/Safety"],
  ["ticket", "Ticket/Entry"],
  ["star", "Highlight/Rating"],
  ["heart", "Favorite"],
  ["gift", "Inclusion/Bonus"],
  ["credit-card", "Payment"],
  ["phone", "Contact"],
  ["information-circle", "Info"],
  ["bolt", "Fast/Express"],
  ["check-circle", "Confirmed"],
  ["flag", "Start/Milestone"],
  ["briefcase", "Luggage/Business"],
  ["camera", "Photo op"],
];

export const QUICK_FACT_ICONS = ICON_NAMES.map(([name, label]) => ({
  value: `${HEROICONS_BASE}/${name}.svg`,
  label,
}));
